import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {GameCenterHeaderModuleTerms} from "./game-center-header-module.terms";

export class GameCenterHeaderConfig extends BaseConfig {

  static injectables = [GameCenterHeaderModuleTerms];

  constructor(terms: GameCenterHeaderModuleTerms) {
    super('gameCenterHeaderModule', null, terms);
  }
}
